import React from "react";
import "../styles/career.css";
import farewellImage from "../assets/last ride.png";

const careerStats = [
  {
    heading: "Appearances & caps",
    items: [
      { value: "861", label: "Total appearances" },
      { value: "755", label: "Club matches" },
      { value: "106", label: "Germany caps" },
    ],
  },
  {
    heading: "The conductor's influence",
    items: [
      { value: "15,872", label: "Final-third passes" },
      { value: "274", label: "Big chances created" },
      { value: "168", label: "Assists" },
      { value: "73", label: "Goals" },
    ],
  },
  {
    heading: "A cabinet of silverware",
    items: [
      { value: "34", label: "Trophies won" },
      { value: "6", label: "Champions League titles" },
      { value: "8", label: "League titles" },
      { value: "1", label: "World Cup" },
    ],
  },
];

function ToniKroosCareer() {
  return (
    <main className="career-page">
      <section className="farewell-section" aria-labelledby="farewell-title">
        <figure className="farewell-visual">
          <img
            className="farewell-image"
            src={farewellImage}
            alt="Toni Kroos salutes the crowd after his final Real Madrid match"
          />
          <figcaption className="farewell-caption">
            <span>Madrid, 2024</span>
            <span>One last night at the summit</span>
          </figcaption>
        </figure>

        <div className="farewell-copy">
          <h1 id="farewell-title">A champion&apos;s farewell</h1>
          <p className="farewell-description">
            After a decade at Real Madrid, Toni Kroos chose to leave at the
            summit. His final club appearance brought a fifth Champions League
            title in Madrid and a sixth overall. At 34, he walked away on his
            own terms, with the game still at his feet.
          </p>
          <blockquote className="farewell-quote">
            <p>“The Real Madrid jersey will be the last one I wear.”</p>
            <cite>Toni Kroos</cite>
          </blockquote>
          <div className="farewell-dates" aria-label="Final season milestones">
            <div>
              <span className="date-marker">01 JUN</span>
              <span className="date-description">Final club match</span>
            </div>
            <div>
              <span className="date-marker">JUL 2024</span>
              <span className="date-description">
                Final international chapter
              </span>
            </div>
          </div>
        </div>
      </section>

      <section className="career-numbers" aria-labelledby="numbers-title">
        <header className="numbers-heading">
          <div>
            <h2 id="numbers-title">The maestro&apos;s legacy in numbers</h2>
          </div>
          <div className="precision-stat">
            <span className="precision-value">
              93.28<span>%</span>
            </span>
            <span className="precision-label">Pass completion</span>
          </div>
        </header>

        <div className="numbers-groups">
          {careerStats.map((group) => (
            <section className="numbers-group" key={group.heading}>
              <h3>{group.heading}</h3>
              <dl>
                {group.items.map(({ value, label }) => (
                  <div className="number-row" key={label}>
                    <dt>{label}</dt>
                    <dd>{value}</dd>
                  </div>
                ))}
              </dl>
            </section>
          ))}
        </div>
      </section>
    </main>
  );
}

export default ToniKroosCareer;
